import { getAuthUser } from "./auth";

const stripTrailingSlash = (value) => value.replace(/\/+$/, "");

const rawBaseUrl = process.env.REACT_APP_API_BASE_URL || "http://localhost:5000/api";
const API_BASE_URL = stripTrailingSlash(rawBaseUrl);

export const apiFetch = async (path, { method = 'GET', data, headers, ...rest } = {}) => {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;

  const config = {
    method,
    headers: {
      'Content-Type': 'application/json',
      ...headers,
    },
    ...rest,
  };

  try {
    const authUser = getAuthUser();
    const userId =
      authUser?.id || (typeof authUser?._id === "string" ? authUser._id : undefined);
    if (userId) {
      config.headers = {
        ...config.headers,
        'x-user-id': userId.toString(),
      };
    }
  } catch (error) {
    // ignore lookup failures; request will proceed without identifier
  }

  if (data !== undefined) {
    config.body = typeof data === 'string' ? data : JSON.stringify(data);
  }

  let response;
  try {
    response = await fetch(`${API_BASE_URL}${normalizedPath}`, config);
  } catch (networkError) {
    const error = new Error('Network request failed');
    error.cause = networkError;
    error.networkError = true;
    error.details = networkError.message || 'Failed to connect to server';
    throw error;
  }

  const contentType = response.headers.get('content-type');
  const isJson = contentType && contentType.includes('application/json');

  const responseData = isJson ? await response.json().catch(() => null) : null;

  if (!response.ok) {
    const error = new Error(responseData?.message || 'Request failed');
    error.status = response.status;
    error.data = responseData;
    throw error;
  }

  return responseData;
};

export const getApiBaseUrl = () => API_BASE_URL;
